import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css' // Import Tailwind CSS
import '@fortawesome/fontawesome-free/css/all.css' // Import Font Awesome CSS
createApp(App).mount('#app')
